import { render } from "./AboutUsBeginInfo.vue?vue&type=template&id=ea78da80&scoped=true"
import script from "./AboutUsBeginInfo.vue?vue&type=script&lang=js"
export * from "./AboutUsBeginInfo.vue?vue&type=script&lang=js"

import "./AboutUsBeginInfo.vue?vue&type=style&index=0&id=ea78da80&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea78da80"]])

export default __exports__